<script setup lang="ts">
type Props = {
  /** Category name, rendered uppercase (HUB, CONTENT, MODULE, ...). */
  label: string;
};

defineProps<Props>();
</script>

<template>
  <p class="text-caption w-full text-on-surface-primary uppercase">
    {{ label }}
  </p>
</template>
